import { apiUrl } from "./base";

export interface ReportAPI {
  id: string;
  sessionId: string;
  contactType: string;
  reportType: string;
  status: "draft" | "final";
  version: number;
  templateKey: string;
  templateVersion: number;
  content: any;
  updatedAt?: string;
}

export async function getReport(sessionId: string): Promise<ReportAPI> {
  const res = await fetch(apiUrl(`/api/sessions/${sessionId}/report`));
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function generateReport(
  sessionId: string,
  opts?: {
    contactType?: string;
    forceNewVersion?: boolean;
    overwrite?: boolean;
  }
): Promise<ReportAPI> {
  const res = await fetch(
    apiUrl(`/api/sessions/${sessionId}/report`),
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(opts || {}),
    }
  );
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function saveReport(
  sessionId: string,
  id: string,
  payload: { status?: "draft" | "final"; content?: any }
): Promise<ReportAPI> {
  const res = await fetch(
    apiUrl(`/api/sessions/${sessionId}/report/${id}`),
    {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    }
  );
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

// Templates API (POC)
export async function listTemplates(): Promise<{
  templates: { key: string; title: string; version: number }[];
}> {
  const res = await fetch(apiUrl("/api/templates"));
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function getTemplate(key: string): Promise<any> {
  const res = await fetch(
    apiUrl(`/api/templates/${encodeURIComponent(key)}`)
  );
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function saveTemplate(key: string, data: any): Promise<any> {
  const res = await fetch(
    apiUrl(`/api/templates/${encodeURIComponent(key)}`),
    {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    }
  );
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function downloadReportPDF(
  sessionId: string,
  reportId: string
): Promise<void> {
  const res = await fetch(
    apiUrl(`/api/sessions/${sessionId}/report/${reportId}?format=pdf`)
  );
  if (!res.ok) {
    const errorText = await res.text();
    throw new Error(errorText || "Failed to download PDF");
  }

  // Get filename from Content-Disposition header or generate default
  const contentDisposition = res.headers.get("Content-Disposition");
  let filename = `report-${sessionId}.pdf`;
  if (contentDisposition) {
    const matches = contentDisposition.match(/filename="(.+)"/);
    if (matches) filename = matches[1];
  }

  // Create blob and trigger download
  const blob = await res.blob();
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}